export const POPUP_FEATURE_TEXT_MAP = {
    'resumes.edit' : {
        title: 'Get seen, get hired.',
        description: 'Resumes getting ignored? Start landing interviews with ResumAI.',
    },
    'resume-tool' : {
        title: 'Get seen, get hired.',
        description: 'Resumes getting ignored? Start landing interviews with ResumAI.',
    },
    'community': {
        title: 'Proof, not promises.',
        description: 'Want to see real resumes that landed interviews? Get access now.'
    },
    'job-board-search' : {
        title: 'A smarter job board.',
        description: 'Still manually tailoring your resumes? Unlock your faster, easier job search.'
    }
}